// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-largeOnConfined-badge-1e848967"};